import { STEPS } from "../../config/landingConfig";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";

const BADGE_COLORS = [
  "bg-cyan text-ink",
  "bg-magenta text-white",
  "bg-violet text-white",
  "bg-cyan text-ink",
  "bg-magenta text-white",
];

export const Steps = () => (
  <section data-testid="steps-section" className="bg-white">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-28">
      <Reveal>
        <SectionTag number="02" label="Proces" color="bg-cyan" />
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Od pomysłu do gotowej <span className="marker-cyan">aktywności na speaking</span>
        </h2>
      </Reveal>

      <div className="relative mt-12">
        <div
          className="absolute left-6 top-0 h-full w-1 rounded bg-ink/15 lg:left-0 lg:top-8 lg:h-1 lg:w-full"
          aria-hidden="true"
        />
        <ol className="grid gap-8 lg:grid-cols-5 lg:gap-5">
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.12} className="h-full">
              <li data-testid={`step-card-${step.n}`} className="relative flex gap-5 lg:h-full lg:flex-col">
                <span className={`font-display z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border-2 border-ink text-xl shadow-hard-sm lg:h-16 lg:w-16 lg:text-2xl ${BADGE_COLORS[i]}`}>
                  {step.n}
                </span>
                <div className="flex-1 rounded-2xl border-2 border-ink bg-white p-5 shadow-hard-sm lg:mt-4 lg:h-full">
                  <h3 className="text-base font-extrabold text-ink">{step.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-ink/75">{step.text}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
